export const memoize = (
  func: (...args: never[]) => Intl.NumberFormat,
  resolver: (...args: never[]) => string
) => {
  const memoized = (...args: never[]) => {
    const key = resolver(...args)
    if (memoized.cache.has(key)) {
      return memoized.cache.get(key)
    }
    const result = func(...args)
    memoized.cache.set(key, result)
    return result
  }
  memoized.cache = new Map()

  return memoized
}
